<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryPackageResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      withCustomRowActions
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-warehouse"
                                               :disabled="actionDisabled('select')"
                                               :showName="true"
                                               custom-label="盘点"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openPackageCheck()"
                                    >
                                    </em-button>
                                    <em-button type="save" custom-icon="fa fa-fw fa-lg fa-box-open"
                                               :disabled="actionDisabled('select')"
                                               :showName="true"
                                               custom-label="拆箱"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openUnpackageDialog()"
                                    >
                                    </em-button>
                                    <em-button type="save" custom-icon="fa fa-fw fa-lg fa-tasks"
                                               :disabled="actionDisabled('selectOne')"
                                               :showName="true"
                                               custom-label="查看/调整物料"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openAdjustDialog()"
                                    >
                                    </em-button>
                                    <em-button type="save" custom-icon="fa fa-fw fa-lg fa-tasks"
                                               :disabled="actionDisabled('selectOne')"
                                               :showName="true"
                                               custom-label="查看/调整内箱"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openAdjustInnerBoxDialog()"
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-truck-loading"
                                               :disabled="actionDisabled('select')"
                                               :showName="true"
                                               custom-label="装车"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openShipmentDialog()"
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-file-export"
                                               :busy=generatingMark
                                               :disabled="actionDisabled('selectOne')"
                                               :showName="true"
                                               custom-label="生成唛头"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="generateShippingMark()"
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-file-export"
                                               :busy=generatingDetail
                                               :disabled="actionDisabled('selectOne')"
                                               :showName="true"
                                               custom-label="生成箱单明细"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="generateDetailPackingList()"
                                    >
                                    </em-button>
                                    <em-button type="save" custom-icon="fa fa-fw fa-lg fa-check"
                                               :busy="checking"
                                               :disabled="actionDisabled('select')"
                                               :showName="true"
                                               confirm-text="审核通过？"
                                               custom-label="审核"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="check()"
                                    >
                                    </em-button>
                                    <em-button type="save" custom-icon="fa fa-fw fa-lg fa-check"
                                               :busy="reviewing"
                                               :disabled="actionDisabled('select')"
                                               :showName="true"
                                               confirm-text="复核通过？"
                                               custom-label="复核"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="review()"
                                    >
                                    </em-button>
                                    <em-button
                                        type='search'
                                        class="btn btn-outline-primary btn-sm"
                                        custom-label="打印箱码"
                                        showName
                                        :disabled="actionDisabled('selectOne')"
                                        @click="gotoPrint()"
                                    >
                                    </em-button>
                                </template>
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoChild(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="unpackageVisible" title="拆箱" width="30%"
                   @close='clearUnpackageReason'>
            <el-form :model="unpackageForm" ref="unpackageForm" label-width="auto" size="mini">
                <el-form-item label="拆箱原因">
                    <el-input v-model="unpackageForm.unpackageReason" type="textarea"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="unpackageVisible = false">取 消</el-button>
                <el-button type="primary" @click="onpenBox()" :disabled="checkUnpackageReason">确认拆箱</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="packageCheckVisible" title="盘点" width="30%"
                   @close='clearStorageArea'>
            <el-select v-model="storageArea" placeholder="请选择">
                <el-option v-for="area in areaOptions" :key="area.id" :label="area.text" :value="area.id">

                </el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="packageCheckVisible = false">取 消</el-button>
                <el-button type="primary" @click="checkPackage()" :disabled="checkSelectedArea">确认盘点</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="shipmentVisible" title="装车"
                   @close='clearShipmentForm'>
            <el-form :model="shipmentForm" ref="shipmentForm" label-width="auto" size="mini" :inline="true">
                <el-form-item label="收货方">
                    <el-input v-model="shipmentForm.receiptCompany"></el-input>
                </el-form-item>
                <el-form-item label="收货地址">
                    <el-input v-model="shipmentForm.receiptAddress"></el-input>
                </el-form-item>
                <el-form-item label="收货人">
                    <el-input v-model="shipmentForm.receiptPerson"></el-input>
                </el-form-item>
                <el-form-item label="收货人电话">
                    <el-input v-model="shipmentForm.receiptPhoneNum"></el-input>
                </el-form-item>
                <el-form-item label="发货参考号">
                    <el-input v-model="shipmentForm.ucrNo"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="shipmentVisible = false">取 消</el-button>
                <el-button type="primary" @click="createShipment()" :disabled="checkPackageForm">确认装车</el-button>
            </div>
        </el-dialog>
        <!--调整箱中的物料对话框，点击添加会弹出子对话框用于添加转交物料-->
        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="packageAdjustVisible" title="调整物料" width="60%"
                   @close='clearAdjustForm'>
            <el-table ref="packingTable" :data="packagedMaterial" max-height="285px" style="width:100%"
                      @selection-change="handleChange" >
                <!-- 改为使用行尾的删除按钮删除，选择框隐藏 -->
                <!-- <el-table-column type="selection" width="30"></el-table-column> -->
                <el-table-column label="项目号" prop="projectCode"></el-table-column>
                <el-table-column label="物料名" prop="materialName"></el-table-column>
                <el-table-column label="物料号" prop="materialCode"></el-table-column>
                <el-table-column label="发货码" prop="deliveryCode"></el-table-column>
                <el-table-column label="单位" prop="unit"></el-table-column>
                <el-table-column label="包装数量">
                    <template slot-scope="scope">
                        <el-input clearable v-model="scope.row.quantity" size="mini"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="拍照">
                    <template slot-scope="scope">
                        <DiverseInput without-label
                                @change="changeAttachmentIds(scope.$index, $event)" :config="config" value="">
                        </DiverseInput>
                    </template>
                </el-table-column>
                <el-table-column fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog :close-on-click-modal='false' :visible.sync="childDialogVisible" append-to-body
                       title="选择物料(已清点的转交物料)"
                       width="60%" @close='closeChildDialog'>
                <el-form ref="filterForm" :inline="true" :model="filterForm" label-position="left" label-width="auto"
                         size="mini">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="物料名称：">
                                <el-input v-model="filterForm.filterString"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="发货码：">
                                <el-input v-model="filterForm.deliveryCode"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="物料号：">
                                <el-input v-model="filterForm.materialCode"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="4" :offset="10">
                            <el-button-group>
                                <el-button :loading="isSearching" icon="el-icon-search" size="mini" type="primary"
                                           @click="findDeliveryMaterials">搜索
                                </el-button>
                                <el-button icon="el-icon-delete" size="mini" type="danger" @click="resetFilterForm">
                                    重置
                                </el-button>
                            </el-button-group>
                        </el-col>
                    </el-row>
                </el-form>

                <el-table ref="deliveryTable" :data="deliveryMaterials" max-height="285px" style="width:100%"
                          @selection-change="handleChildChange">
                    <el-table-column type="selection" width="30"></el-table-column>
                    <el-table-column label="物料名" prop="deliveryDescription"></el-table-column>
                    <el-table-column label="发货码" prop="deliveryCode"></el-table-column>
                    <el-table-column label="项目号" prop="projectCode"></el-table-column>
                    <el-table-column label="单位" prop="unit"></el-table-column>
                    <el-table-column label="物料号" prop="materialCode"></el-table-column>
                    <el-table-column label="转交数量" prop="quantity"></el-table-column>
                    <el-table-column label="已包装数量" prop="packagedQuantity"></el-table-column>
                </el-table>
                <el-dialog :center="true" :close-on-click-modal='false' :visible.sync="matScannerVisible" append-to-body
                           title="扫一扫" @close="closeMatScanner">
                    <qr-code-scanner ref="matScanner" @getCodeData='getMaterialInfo'>
                    </qr-code-scanner>
                </el-dialog>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="openMatScanner()">扫描识别</el-button>
                    <el-button @click="childDialogVisible = false">取 消</el-button>
                    <el-button :disabled="selectedDeliveryMaterial.length === 0" type="primary"
                               @click="confirmSelection()">确认
                    </el-button>
                </div>
            </el-dialog>

            <div slot="footer" class="dialog-footer">
                <!-- <el-button @click="deleteMaterial()" :disabled="noSelect">删除</el-button> -->
                <el-button @click="loadDeliveryMaterial()">添加</el-button>
                <el-button @click="packageAdjustVisible = false">取 消</el-button>
                <el-button type="primary" @click="adjustPackage()" :disabled="checkIfReady">确认</el-button>
            </div>
        </el-dialog>
        <!-- 调整内包装箱的对话框 -->
        <el-dialog :close-on-click-modal='false' append-to-body :visible.sync="adjustInnerBoxVisible" title="调整内箱" width="60%"
                   @close='closeAdjustInnerBox'>
            <el-table ref="innerBoxTable" :data="currentInnerBox" max-height="285px" style="width:100%"
                      @selection-change="changeSelectedInner">
                <el-table-column type="selection" width="30"></el-table-column>
                <el-table-column label="箱号" prop="boxNo"></el-table-column>
                <el-table-column label="项目号" prop="projectCode"></el-table-column>
                <el-table-column label="包装编号" prop="packageNo"></el-table-column>
                <el-table-column label="内容描述" prop="description"></el-table-column>
                <el-table-column label="长/mm" prop="length"></el-table-column>
                <el-table-column label="宽/mm" prop="width"></el-table-column>
                <el-table-column label="高/mm" prop="height"></el-table-column>
                <el-table-column label="净重/kg" prop="netWeight"></el-table-column>
                <el-table-column label="毛重/kg" prop="roughWeight"></el-table-column>
            </el-table>
            <el-dialog :close-on-click-modal='false' :visible.sync="adjustInnerBoxChildVisible" append-to-body
                       title="选择小箱"
                       width="60%" @close='closeAdjustInnerBoxChild'>
                <el-row>
                    <el-col :span="12">
                        <el-form :model="filterForm" :inline=true label-position="left">
                            <el-form-item label="箱号">
                                <el-input v-model="filterForm.filterString"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="12">
                        <el-button-group>
                            <el-button type="primary" icon="el-icon-search" @click="findInnerBox">搜索</el-button>
                            <el-button type="danger" icon="el-icon-delete" @click="resetFilterForm">重置</el-button>
                        </el-button-group>
                    </el-col>
                </el-row>
                <!-- 根据箱号搜索出的，未装进大箱的小箱 -->
                <el-table ref="optionalInnerBoxTable" :data="optionalInnerBox" max-height="285px" style="width:100%"
                          @selection-change="handleInnerBoxChange">
                    <el-table-column type="selection" width="30"></el-table-column>
                    <el-table-column label="箱号" prop="boxNo"></el-table-column>
                    <el-table-column label="项目号" prop="projectCode"></el-table-column>
                    <el-table-column label="包装编号" prop="packageNo"></el-table-column>
                    <el-table-column label="内容描述" prop="description"></el-table-column>
                    <el-table-column label="长/mm" prop="length"></el-table-column>
                    <el-table-column label="宽/mm" prop="width"></el-table-column>
                    <el-table-column label="高/mm" prop="height"></el-table-column>
                    <el-table-column label="净重/kg" prop="netWeight"></el-table-column>
                    <el-table-column label="毛重/kg" prop="roughWeight"></el-table-column>
                </el-table>
                <el-dialog :center="true" :close-on-click-modal='false' :visible.sync="pacScannerVisible" append-to-body
                           title="扫一扫" @close="closePacScanner">
                    <qr-code-scanner ref="pacScanner" @getCodeData='getPackageInfo'>
                    </qr-code-scanner>
                </el-dialog>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="openPacScanner()">扫描识别</el-button>
                    <el-button @click="adjustInnerBoxChildVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmSelectedBox()">确认</el-button>
                </div>
            </el-dialog>
            <div slot="footer" class="dialog-footer">
                <el-button @click="deleteInnerBox()" :disabled="noInnerBoxSelect">删除</el-button>
                <el-button @click="addInnerBox()">添加</el-button>
                <el-button @click="adjustInnerBoxVisible = false">取 消</el-button>
                <el-button type="primary" @click="finishAdjustInnerBox()">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// Author Lin
// Date 2021-05-25 11:20:01

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput.vue";

export default {
    name: "sithMesInventoryPackageListView",
    mixins: [emCommonListMixin, emCommonApiMixin, emCommonGotoMixin, emTableCheckedMixin],
    components: {DiverseInput, qrCodeScanner},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        },
        onComplete: false,
    },
    data() {
        return {
            config:{
                type:'image',
            },
            packageCheckVisible: false,
            shipmentVisible: false,
            unpackageVisible: false,
            packageAdjustVisible: false,
            childDialogVisible: false,
            unpackageForm: {
                unpackageReason: ''
            },
            checkForm: {
                location: ''
            },
            storageArea: '',
            areaOptions: [],
            shipmentForm: {
                receiptCompany: '',
                receiptAddress: '',
                receiptPerson: '',
                receiptPhoneNum: '',
                ucrNo: '',
            },
            filterForm: {
                filterString: '',
                deliveryCode: '',
                materialCode: '',
            },
            selectedPackagedMaterial: [],
            selectedDeliveryMaterial: [],
            packagedMaterial: [],
            deliveryMaterials: [],
            // 显示调整内包装箱对话框
            adjustInnerBoxVisible: false,
            // 当前外箱包含的内包装箱
            currentInnerBox: [],
            // 选中准备删除的内包装箱
            selectedInnerBox: [],
            // 打开选择内包装箱的对话框
            adjustInnerBoxChildVisible: false,
            // 可选的内包装箱，即小箱子
            optionalInnerBox: [],
            // 新增的内箱
            addedInnerBox: [],
            generatingMark: false,
            generatingDetail: false,
            checking: false,
            reviewing: false,
            isSearching: false,
            matScannerVisible: false,
            pacScannerVisible: false,
            attachmentIds: [],
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"];
        },
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"].join(",");
        },
        checkPackageForm() {
            let obj = this.shipmentForm;
            for (const key in obj) {
                if (obj[key] === null || obj[key] === '') {
                    return true;
                }
            }
            return false;
        },
        checkSelectedArea() {
            if (this.storageArea === null || this.storageArea === '') {
                return true;
            }
            return false;
        },
        checkUnpackageReason() {
            if (this.unpackageForm.unpackageReason === null || this.unpackageForm.unpackageReason === '') {
                return true;
            }
            return false;
        },
        checkIfSelectOne() {
            return this.selectedDeliveryMaterial.length === 1;
        },
        checkIfReady() {

        },
        noSelect() {
            return this.selectedPackagedMaterial.length === 0;
        },
        // 判断删除按钮是否可选
        noInnerBoxSelect() {
            return this.selectedInnerBox.length === 0;
        }
    },
    methods: {
        changeAttachmentIds(index,ids) {
            this.attachmentIds[index]=ids;
        },
        actionDisabled(type) {
            // 删除按钮在一条记录都没选的时候禁用
            if (type === "select") {
                return this.checkedItems && this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else if (type === "selectOne") {
                return this.checkedItems && this.checkedItems.length !== 1;
            }
            //多选或者选择的包装箱未拆解时禁用
            else if (type === "selectUnpackagedOne") {
                let self = this;
                let choosenArry = this.$store.state[this.modelName]["rows"].filter(function (x) {
                    return self.checkedItems.indexOf(x.id) > -1;
                });
                return choosenArry.length !== 1 || choosenArry[0].logisticsStatus !== 7;
            }
        },
        openPackageCheck() {
            this.packageCheckVisible = true;
        },
        openShipmentDialog() {
            this.shipmentVisible = true;
        },
        openUnpackageDialog() {
            this.unpackageVisible = true;
        },
        clearCheckForm() {
            this.checkForm.location = '';
        },
        clearStorageArea() {
            this.storageArea = '';
        },
        clearUnpackageReason() {
            this.unpackageForm.unpackageReason = '';
        },
        clearShipmentForm() {
            this.shipmentForm.receiptCompany = '';
            this.shipmentForm.receiptAddress = '';
            this.shipmentForm.receiptPerson = '';
            this.shipmentForm.receiptPhoneNum = '';
            this.shipmentForm.ucrNo = '';
        },
        checkPackage() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryPackage")}/checkPackage?ids=${this.selectIds}&areaId=${this.storageArea}`;
            this.$_emApiMixin_post(url, {})
                .then((request) => {
                    if (request.status === 200) {
                        self.$message({
                            message: "盘点成功",
                            type: "success",
                        });

                        self.$refs.emListFilter.doQuery();
                    } else {
                        self.$message({
                            message: "盘点失败",
                            type: "error",
                        });
                    }
                }).finally(() => {
                this.packageCheckVisible = false;
            })
        },
        createShipment() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryShipment")}/createShipment`;
            let requestBody = {};
            let ids = self.selectIds;
            requestBody.idStr = ids;
            requestBody.receiptCompany = self.shipmentForm.receiptCompany;
            requestBody.receiptAddress = self.shipmentForm.receiptAddress;
            requestBody.receiptPerson = self.shipmentForm.receiptPerson;
            requestBody.receiptPhoneNum = self.shipmentForm.receiptPhoneNum;
            requestBody.ucrNo = self.shipmentForm.ucrNo;
            self.$_emApiMixin_post(url, requestBody)
                .then((request) => {
                    if (request.status === 200) {
                        self.$message({
                            message: "创建发货任务完成",
                            type: "success",
                        });

                        self.$refs.emListFilter.doQuery();
                    } else {
                        self.$message({
                            message: "创建发货任务失败",
                            type: "error",
                        });
                    }
                })
                .finally(() => {
                    this.shipmentVisible = false;
                });
        },
        onpenBox() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/openBox?ids=${this.selectIds}&reason=${this.unpackageForm.unpackageReason}`
            self.$_emApiMixin_post(url, {})
                .then(response => {
                    if (response.status === 200) {
                        self.$message({
                            message: "拆箱成功",
                            type: "success",
                        });

                        self.$refs.emListFilter.doQuery();
                    } else {
                        self.$message({
                            message: "拆箱失败",
                            type: "error",
                        });
                    }
                })
                .finally(() => this.unpackageVisible = false)
        },
        gotoChild(row) {
            this.$_emGotoMixin_gotoHolderList(
                    "sithMesInventoryPackageMaterial",
                    {packageIdFilter: row.id},
                    {packageId: row.id},
                false,
                    {
                        customVuexName: this.customVuexName,
                        packageId: row.id
                    },
                    "findByFilter",
                    "packageFilter",
                    "entity",
                    "sithMesInventoryPackageMaterialList"
            )
        },
        getStorageLocation() {
            this.$_emApiMixin_findByFilter("sithMesInventoryAreaLoc", {})
                .then(data => {
                    this.areaOptions = data.map(m => {
                        return {id: m.id, text: m.areaName}
                    })
                })
        },
        openAdjustDialog() {
            let self = this;
            self.packageAdjustVisible = true;
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryPackageMaterial")}/getPackageMaterial?ids=${self.checkedItems}`
            self.$_emApiMixin_post(url, {})
                .then(response => {
                    self.packagedMaterial = response.data.list;
                })
        },
        findDeliveryMaterials() {
            let self = this;
            self.isSearching = true;
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryDeliveryMaterial")}/findDeliveryMaterials?deliveryDescription=${self.filterForm.filterString}&deliveryCode=${self.filterForm.deliveryCode}&materialCode=${self.filterForm.materialCode}`
            self.$_emApiMixin_post(url, {})
                .then(response => {
                    self.deliveryMaterials = response.data.list;
                    self.isSearching = false;
                })
        },
        clearAdjustForm() {
            this.packagedMaterial = [];
            this.selectedPackagedMaterial = [];
        },
        closeChildDialog() {
            this.filterForm.filterString = '';
            this.filterForm.deliveryCode = '';
            this.filterForm.materialCode = '';
            this.deliveryMaterials = [];
            this.selectedDeliveryMaterial = [];
        },
        //控制删除时只能单选--已废弃，删除物料改为使用每一行尾的删除按钮调用handleDelete
        handleChange(selection) {
            if (selection.length > 1) {
                this.$refs.packingTable.clearSelection()
                this.$refs.packingTable.toggleRowSelection(selection.pop());
            } else {
                this.selectedPackagedMaterial = selection;
            }
        },
        // 行尾删除按钮触发
        handleDelete(index) {
            this.packagedMaterial.splice(index, 1);
        },
        handleChildChange(selection) {
            this.selectedDeliveryMaterial = selection;
        },
        deleteMaterial() {
            this.packagedMaterial.splice(this.packagedMaterial.indexOf(this.selectedPackagedMaterial[0]), 1);
        },
        loadDeliveryMaterial() {
            this.childDialogVisible = true;
        },
        confirmSelection() {
            this.childDialogVisible = false;
            for (let i = 0, length = this.selectedDeliveryMaterial.length; i < length; i++) {
                let mat = this.selectedDeliveryMaterial[i];
                // 如果选择的物料已经添加过则跳过
                if (this.matAlreadyExsit(mat)) {
                    this.$message.error("该物料已添加，请勿重复添加！");
                    return;
                }

                let obj = {};
                obj.materialId = mat.id;
                obj.materialName = mat.deliveryDescription;
                obj.materialCode = mat.materialCode;
                obj.unit = mat.unit;
                obj.deliveryCode = mat.deliveryCode;
                if (typeof (mat.packagedQuantity) == "undefined") {
                    obj.quantity = mat.quantity;
                } else {
                    obj.quantity = mat.quantity - mat.packagedQuantity;
                }

                this.packagedMaterial.push(obj);
            }
        },
        matAlreadyExsit(mat) {
            for (let i = 0, length = this.packagedMaterial.length; i < length; i++) {
                if (this.packagedMaterial[i].materialId === mat.id) {
                    return true;
                }
            }
            return false;
        },
        adjustPackage() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/adjustPackageMaterial?ids=${this.selectIds}`;
            for (let i = 0, length = self.packagedMaterial.length; i < length; i++) {
                if (this.attachmentIds[i]) {
                    if (self.packagedMaterial[i].unpackingAttachment) {
                        self.packagedMaterial[i].unpackingAttachment = self.packagedMaterial[i].unpackingAttachment + "," + this.attachmentIds[i];
                    } else {
                        self.packagedMaterial[i].unpackingAttachment = this.attachmentIds[i];
                    }
                }
            }
            this.$_emApiMixin_post(url, {packageMaterialVos: self.packagedMaterial})
                .then((request) => {
                    if (request.status === 200) {
                        self.$message({
                            message: "调整物料成功",
                            type: "success",
                        });

                        self.$refs.emListFilter.doQuery();
                    } else {
                        self.$message({
                            message: "调整物料失败",
                            type: "error",
                        });
                    }
                }).finally(() => {
                this.packageAdjustVisible = false;
            })
        },
        generateShippingMark() {
            let self = this;
            self.generatingMark = true;
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/generateShippingMark?id=${this.selectIds}`;
            this.$_emApiMixin_post(url, {})
                .then((request) => {
                    if (request.status === 200) {
                        self.$message({
                            message: "正在生成唛头",
                            type: "success",
                        });
                    } else {
                        self.$message({
                            message: "生成唛头失败",
                            type: "error",
                        });
                    }
                }).finally(() => {
                self.generatingMark = false;
            });
        },
        // 生成箱单明细
        generateDetailPackingList() {
            let self = this;
            self.generatingDetail = true;
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/generateDetailPackingList?packageId=${this.selectIds}`;
            this.$_emApiMixin_post(url, {})
                .then((request) => {
                    if (request.status === 200) {
                        self.$message({
                            message: "正在生成箱单明细",
                            type: "success",
                        });
                    } else {
                        self.$message({
                            message: "生成箱单明细失败",
                            type: "error",
                        });
                    }
                }).finally(() => this.generatingDetail = false)
        },
        // 打开对话框，并查询当前包装箱中包含的内箱
        openAdjustInnerBoxDialog() {
            let self = this;

            let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryPackage")}/getCurrentInnerBox?id=${self.checkedItems}`
            self.$_emApiMixin_post(url, {})
                .then(response => {
                    if (response.status === 200) {
                        if (response.data instanceof Array) {
                            self.currentInnerBox = response.data;
                        }
                        self.adjustInnerBoxVisible = true;
                    } else {
                        self.$message({
                            message: "获取内箱失败",
                            type: "error",
                        });
                    }

                })
        },
        // 关闭调整内箱对话框，
        closeAdjustInnerBox() {
            this.currentInnerBox = [];
            this.selectedInnerBox = [];
        },
        changeSelectedInner(selection) {
            this.selectedInnerBox = selection;
        },
        closeAdjustInnerBoxChild() {
            this.filterForm.filterString = '';
            this.addedInnerBox = [];
            this.optionalInnerBox = [];
        },
        deleteInnerBox() {
            this.currentInnerBox = this.currentInnerBox.filter(box => this.selectedInnerBox.indexOf(box) === -1)
        },
        addInnerBox() {
            this.adjustInnerBoxChildVisible = true;
        },
        handleInnerBoxChange(selection) {
            this.addedInnerBox = selection;
        },
        confirmSelectedBox() {
            this.adjustInnerBoxChildVisible = false;
            for (let i = 0, length = this.addedInnerBox.length; i < length; i++) {
                if (this.currentInnerBox.findIndex(x => x.id === this.addedInnerBox[i].id) === -1) {
                    this.currentInnerBox.push(this.addedInnerBox[i]);
                }
            }
            this.addedInnerBox = [];
        },
        findInnerBox() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryPackage")}/findUnpackagedInnerBox?boxNo=${self.filterForm.filterString}`
            self.$_emApiMixin_post(url, {})
                .then(response => {
                    if (response.data instanceof Array) {
                        self.optionalInnerBox = response.data.filter(box => {
                            return typeof (box.parentId) == "undefined" || box.parentId === null;
                        });
                    }
                })
        },
        finishAdjustInnerBox() {
            let self = this;
            let innerBoxIds = this.currentInnerBox.map(innerBox => {
                return innerBox.id;
            }).join(",");
            let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryPackage")}/finishAdjustInnerBox?outerBoxId=${self.checkedItems}&innerBoxIds=${innerBoxIds}`
            this.$_emApiMixin_post(url, {})
                .then((request) => {
                    if (request.status === 200) {
                        self.$message({
                            message: "调整内箱成功",
                            type: "success",
                        });

                        self.$refs.emListFilter.doQuery();
                    } else {
                        self.$message({
                            message: "调整内箱失败",
                            type: "error",
                        });
                    }
                }).finally(() => {
                this.adjustInnerBoxVisible = false;
            })
        },
        check() {
            let _this = this;
            _this.checking = true;
            let url = `${_this.$_emApiMixin_entityBaseApi(_this.modelName)}/check?ids=${_this.selectIds}`
            _this.$_emApiMixin_post(url, {})
                .then(response => {
                    if (response.status === 200) {
                        _this.$message({
                            message: "审核完成",
                            type: "success",
                        });
                        _this.$refs.emListFilter.doQuery()
                    } else {
                        _this.$message({
                            message: "审核失败",
                            type: "error",
                        });
                    }
                })
                .finally(() => this.checking = false)
        },
        review() {
            let _this = this;
            _this.reviewing = true;
            let url = `${_this.$_emApiMixin_entityBaseApi(_this.modelName)}/review?ids=${_this.selectIds}`
            _this.$_emApiMixin_post(url, {})
                .then(response => {
                    if (response.status === 200) {
                        _this.$message({
                            message: "复核完成",
                            type: "success",
                        });
                        _this.$refs.emListFilter.doQuery()
                    } else {
                        _this.$message({
                            message: "复核失败",
                            type: "error",
                        });
                    }
                })
                .finally(() => this.reviewing = false)
        },
        openMatScanner() {
            this.matScannerVisible = true;
            setTimeout(() => {
                this.$refs.matScanner.openCamera('');
            }, 500);
        },
        openPacScanner() {
            this.pacScannerVisible = true;
            setTimeout(() => {
                this.$refs.pacScanner.openCamera('');
            }, 500);
        },
        getMaterialInfo(data) {
            console.log("get qr code data:" + data);
            this.matScannerVisible = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var materialCode = obj['物料号'];
                var deliveryCode = obj['发货码'];
                console.log(materialCode);
                console.log(deliveryCode);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            self.filterForm.materialCode = materialCode;
            self.filterForm.deliveryCode = deliveryCode;
            self.findDeliveryMaterials();
        },
        getPackageInfo(data) {
            console.log("get qr code data:" + data);
            this.pacScannerVisible = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var boxNo = obj['Storage Bin'];
                console.log(boxNo);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            self.filterForm.filterString = boxNo;
            self.findInnerBox();
        },
        closeMatScanner() {
            this.$refs.matScanner.closeCamera();
            this.$refs.matScanner.resetOutputData();
            this.matScannerVisible = false;
        },
        closePacScanner() {
            this.$refs.pacScanner.closeCamera();
            this.$refs.pacScanner.resetOutputData();
            this.pacScannerVisible = false;
        },
        resetFilterForm() {
            this.filterForm.filterString = '';
            this.filterForm.materialCode = '';
            this.filterForm.deliveryCode = '';
            this.deliveryMaterials = [];
            this.optionalInnerBox = [];
        },
        gotoPrint() {
            this.$router.push({
                name: 'sithMesInventoryBinAddPrint',
                params: {
                    storageType: this.checkedRows[0].packageNo,
                    storageBin: this.checkedRows[0].boxNo,
                    storageLoc: this.checkedRows[0].projectCode,
                    packageId: this.checkedRows[0].id,
                    printType: 'package',
                }
            });
        }
    },
    mounted() {
        this.getStorageLocation();
    }
};
</script>
